export const environment = {
    production: false,
    stage: true,
    development: false,
    apiUrl: "https://staging.app.v3.custm.com.au/api/",
    apiLogin: "https://staging.app.custm.com.au/api/",
    mapboxgl_access_token: 'pk.eyJ1IjoiY2hhcm1hdWJ6MjAiLCJhIjoiY2plcWcxajJrMzljeDMzbWVteXZqa21jMCJ9.kA1ZWii9btzYPwpTp7sPsw',
    onboarding: "https://staging.onboarding.v3.custm.com.au/",
    s3Url: "https://freight-v3-prod.s3.ap-southeast-4.amazonaws.com/",
    pusher: {
        key: "5e5ef3eee5671ded386075b098691579bf0d63e0",
        cluster: "ap2",
        hostName: "127.0.0.1",
        port: "6001",
        authUrl: "https://staging.app.v3.custm.com.au/api/broadcasting/auth"
    },
    firebaseConfig: {
        apiKey: "AIzaSyBywMQepcH4sLVZR2IAHhNBqkfBlKt-C1s",
        authDomain: "freight-firebase-project.firebaseapp.com",
        projectId: "freight-firebase-project",
        storageBucket: "freight-firebase-project.firebasestorage.app",
        messagingSenderId: "157289853235",
        appId: "1:157289853235:web:56fa927b897a9ccc1e4e46"
    }
};
